import React from "react";

const SkeletonCard: React.FC = () => {
  return (
    <div className="bg-card animate-pulse rounded-xl shadow-sm border border-border p-6">
      <div className="h-4 bg-muted rounded w-3/4 mb-4"></div>
      <div className="h-8 bg-muted rounded mb-2"></div>
      <div className="h-4 bg-muted rounded w-1/2"></div>
    </div>
  );
};

export default SkeletonCard;
